import { useEffect } from 'react'
import { downloadOrderLabels } from '@/helper/utils'
import { OrderService } from '@/lib/services/order'
import { useParams } from 'react-router-dom'

const DownloadLabel = () => {
  const route = useParams()

  useEffect(() => {
    const getOrder = async () => {
      const order = await OrderService.getOrderLabels(route.id as string)
      downloadOrderLabels(order)
      window.close()
    }
    getOrder()
  }, [route.id])

  return <div></div>
}

export default DownloadLabel
